import winterUnitsService from "../shared/services/winterUnitsService";

const REQUEST_WINTER_UNITS = "REQUEST_WINTER_UNITS";
const RESPONSE_WINTER_UNITS = "RESPONSE_WINTER_UNITS";
const REQUEST_WINTER_UNITS_FAILURE = "REQUEST_WINTER_UNITS_FAILURE";

const requestWinterUnitsAction = () => {
  return {
    type: REQUEST_WINTER_UNITS,
  };
};

const responseWinterUnitsAction = (data) => {
  return {
    type: RESPONSE_WINTER_UNITS,
    data,
  };
};

const requestWinterUnitsFailureAction = (errors) => {
  return {
    type: REQUEST_WINTER_UNITS_FAILURE,
    errors,
  };
};

const getWinterUnits = (options) => {
  return (dispatch) => {
    dispatch(requestWinterUnitsAction());

    winterUnitsService
      .getWinterUnits(options)
      .then((result) => {
        dispatch(responseWinterUnitsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestWinterUnitsFailureAction(error.response));
      });
  };
};

const REQUEST_ADD_WINTER_UNIT = "REQUEST_ADD_WINTER_UNIT";
const RESPONSE_ADD_WINTER_UNIT = "RESPONSE_ADD_WINTER_UNIT";
const REQUEST_ADD_WINTER_UNIT_FAILURE = "REQUEST_ADD_WINTER_UNIT_FAILURE";

const requestAddWinterUnitAction = () => {
  return {
    type: REQUEST_ADD_WINTER_UNIT,
  };
};

const responseAddWinterUnitAction = (data) => {
  return {
    type: RESPONSE_ADD_WINTER_UNIT,
    data,
  };
};

const requestAddWinterUnitFailureAction = (errors) => {
  return {
    type: REQUEST_ADD_WINTER_UNIT_FAILURE,
    errors,
  };
};

const addWinterUnit = (unit) => {


  return (dispatch) => {
    dispatch(requestAddWinterUnitAction());

    winterUnitsService
      .addUnitWinterUnit({ id: unit.id })
      .then((result) => {
        dispatch(responseAddWinterUnitAction(unit));
      })
      .catch((error) => {
        dispatch(requestAddWinterUnitFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_WINTER_UNIT = "REQUEST_DELETE_WINTER_UNIT";
const RESPONSE_DELETE_WINTER_UNIT = "RESPONSE_DELETE_WINTER_UNIT";
const REQUEST_DELETE_WINTER_UNIT_FAILURE = "REQUEST_DELETE_WINTER_UNIT_FAILURE";

const requestDeleteWinterUnitAction = () => {
  return {
    type: REQUEST_DELETE_WINTER_UNIT,
  };
};

const responseDeleteWinterUnitAction = (data) => {
  return {
    type: RESPONSE_DELETE_WINTER_UNIT,
    data,
  };
};

const requestDeleteWinterUnitFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_WINTER_UNIT_FAILURE,
    errors,
  };
};

const deleteWinterUnit = (unit) => {
  return (dispatch) => {
    dispatch(requestDeleteWinterUnitAction());

    winterUnitsService
      .deleteUnitWinterUnit({ id: unit.id })
      .then((result) => {
        dispatch(responseDeleteWinterUnitAction({ id: unit.id }));
      })
      .catch((error) => {
        dispatch(requestDeleteWinterUnitFailureAction(error.response));
      });
  };
};

export {
  REQUEST_WINTER_UNITS,
  RESPONSE_WINTER_UNITS,
  REQUEST_WINTER_UNITS_FAILURE,
  getWinterUnits,
  REQUEST_ADD_WINTER_UNIT,
  RESPONSE_ADD_WINTER_UNIT,
  REQUEST_ADD_WINTER_UNIT_FAILURE,
  addWinterUnit,
  REQUEST_DELETE_WINTER_UNIT,
  RESPONSE_DELETE_WINTER_UNIT,
  REQUEST_DELETE_WINTER_UNIT_FAILURE,
  deleteWinterUnit,
};
